import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const BIDDERS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('BIDDERS');
export const BIDDERS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	BIDDERS_CRUD_ACTION_CONSTANTS
);
